import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type GoAiguaModalProps = {
    headerTitle: string;
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
    className?: string;
};

const GoAiguaModal: React.FC<GoAiguaModalProps> = ({
    headerTitle,
    isOpen = false,
    setIsOpen,
    className,
    children,
}) => {
    const generateModal = () => {
        const handleModalClick = () => {
            if (window.getSelection()?.toString() !== "") {
                return void 0;
            } else {
                setIsOpen(false);
            }
        };

        const handleEventPropagation = (e: any) => {
            e.stopPropagation();
        };

        if (isOpen) {
            return (
                <div className={"c-goaigua-modal" + " " + className}>
                    <div
                        className={
                            "c-goaigua-modal__overlay " +
                            className +
                            "__overlay"
                        }
                    >
                        <div
                            className={
                                "c-goaigua-modal__overlay-box-wrapper " +
                                className +
                                "__overlay-box-wrapper"
                            }
                            onClick={(e) => handleModalClick()}
                        >
                            <div
                                className={
                                    "c-goaigua-modal__box " +
                                    className +
                                    "__box"
                                }
                                onClick={(e) => handleEventPropagation(e)}
                            >
                                <div
                                    className={
                                        "c-goaigua-modal__header " +
                                        className +
                                        "__header"
                                    }
                                >
                                    <div>{headerTitle}</div>
                                    <div
                                        className={
                                            "c-goaigua-modal__close " +
                                            className +
                                            "__close"
                                        }
                                    >
                                        <FontAwesomeIcon
                                            icon={faTimes}
                                            onClick={
                                                setIsOpen
                                                    ? (e) => setIsOpen(false)
                                                    : void 0
                                            }
                                        />
                                    </div>
                                </div>
                                <div
                                    className={
                                        "c-goaigua-modal__content " + className
                                    }
                                >
                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    };

    return generateModal();
};

export default GoAiguaModal;
